export const APP_NAME = "DazWay";
export const DEVICE_TYPE_DESKTOP = "desktop";